import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { FEATURE_NAME, NOT_FOUND_URL, RISK_MANAGEMENT_LISTING_URL } from '@/constants';
import { useIsLoadedState } from '@/context';
import { useAuth, useFeatureToggle, useIsBeginnerPlan, useVerifyTermsAcceptance } from '@/hooks';

export const useAccessControl = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const isBeginnerPlan = useIsBeginnerPlan();
  const isLoaded = useRecoilValue(useIsLoadedState);
  const { featureToggleState, isOnTheFeatureToggle } = useFeatureToggle({ featureName: FEATURE_NAME });
  const { handleVerifyTermsAcceptance, selfOnboardingState } = useVerifyTermsAcceptance();
  const [isAccessValidated, setIsAccessValidated] = useState(false);

  const handle = () => {
    if (!auth.loaded || !featureToggleState.isLoaded) return;

    handleVerifyTermsAcceptance(auth.user.company.id);
  };

  const redirect = () => {
    if (!isLoaded) return;

    setIsAccessValidated(true);

    if (selfOnboardingState.termsHasBeenAccepted) navigate(RISK_MANAGEMENT_LISTING_URL, { replace: true });
    else if (isBeginnerPlan && !isOnTheFeatureToggle) navigate(NOT_FOUND_URL, { replace: true });
  };

  useEffect(handle, [auth.loaded, featureToggleState.isLoaded]);
  useEffect(redirect, [isLoaded]);

  return { isAccessValidated };
};
